export var Provider;
(function (Provider) {
    Provider["Videoma"] = "VIDEOMA";
    Provider["Medio"] = "MEDIO";
})(Provider || (Provider = {}));
